<template>
  <RightInfoPanelGeneric
    :value="value"
    :title-key="'scale.quantity_warnings.title_info'"
    :items="items"
    :saving="saving"
    @save="$emit('save')"
    @back="$emit('back')"
  />
</template>

<script>
import RightInfoPanelGeneric from "@/components/Common/RightInfoPanelGeneric.vue";

export default {
  name: "QuantityWarningRightPanel",
  components: {
    RightInfoPanelGeneric,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      return [
        {
          labelKey: "common.legal_entity_name",
          path: "legal_entity_name",
          required: true,
        },
        {
          labelKey: "year",
          path: "year",
          required: true,
        },
        {
          labelKey: "common.product",
          path: "products",
          required: true,
          formatter: (val) => {
            const count = Array.isArray(val) ? val.length : 0;
            if (!count) return "*";
            return this.$tc("scale.quantity_warnings.products_selected", count, { count });
          },
        },
      ];
    },
  },
};
</script>
